export const formatPhoneNumber = (value) => {
	const numeros = value.replace(/\D/g, "");

	if (numeros.length <= 10) {
		return numeros.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, "($1) $2-$3-$4");
	}
};